import { commitMutation } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';
import environment from "environments/environment.js"

const mutation = graphql`
    mutation approveEventMutation($input:approveHyeventInput!){
        approveHyevent(input:$input) {
          clientMutationId
          hyevent{
            id
            status
          }
        }
    }
`;


function commit(input) {
  return new Promise((res, rej) => {
    commitMutation(environment, {
      mutation,
      variables: { input },
      onCompleted: res,
      onError: rej
    })
  });
};

export default commit;